import { createGlobalStyle } from 'styled-components'
import { media } from 'utils/style-utils'

export const GlobalScrollSnapStyles = createGlobalStyle`
  html {
    ${media.sm`
      scroll-snap-type: y mandatory;
    `}
  }
`
